import Button from '@mui/material/Button'
import { FormattedMessage } from 'react-intl'
import styles from './ComposerActionsButton.pcss'

interface AddToBucketButtonProps {
  disabled: boolean
  postsCount: number
  className?: string
  onSubmit: () => void
}

export function AddToBucketButton(props: AddToBucketButtonProps) {
  return (
    <div className={`${styles.container} ${props.className || ''}`} data-testid="add-to-bucket-button">
      <Button
        variant="contained"
        color="primary"
        className={styles['btn-main']}
        disabled={props.disabled}
        onClick={props.onSubmit}
      >
        <FormattedMessage id="composer.actions.save-to-bucket" values={{ posts: props.postsCount }} />
      </Button>
    </div>
  )
}

export default AddToBucketButton
